import TodoDetailContainer from "../containers/TodoDetailContainer";

const DetailPage = () => {
  return <TodoDetailContainer />;
};

export default DetailPage;
